// extracted by mini-css-extract-plugin
export default {"temperature":"styles_temperature__Ht-Yg","add_item":"styles_add_item__oEwg6","temperature__ending":"styles_temperature__ending__wbS4b"};